module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }